'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FilterCell = exports.VerticalPaddingCell = exports.HorizontalPaddingCell = exports.PaddingCell = exports.DimensionLabelCell = exports.DimensionEmptyCell = exports.DimensionGrandTotalCell = exports.DimensionSubTotalCell = exports.ColumnAxisCell = exports.RowAxisCell = exports.ValueTotalCell = exports.ValueSubTotalCell = exports.PlainValueCell = exports.ValueCell = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ResponseRowIdCombination = require('../api/ResponseRowIdCombination');

var _PivotTableUtils = require('./PivotTableUtils');

var _uuid = require('d2-utilizr/lib/uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @description factory function for cell with default options.
 *  @returns {object}
 */
var DefaultCell = function DefaultCell() {
    return {
        htmlValue: '&nbsp;',

        collapsed: false,
        hidden: false,
        empty: false,

        colSpan: 1,
        rowSpan: 1,

        width: 120,
        height: 25,

        style: ''
    };
};

var ValueCell = exports.ValueCell = function ValueCell(value, response, rric, uuids, htmlValue) {
    var cell = DefaultCell();

    cell.uuid = (0, _uuid2.default)();
    cell.uuids = uuids;

    cell.value = value;
    cell.htmlValue = value === null || typeof value === 'undefined' ? '&nbsp;' : htmlValue ? htmlValue : value;

    cell.isValue = !cell.empty;

    cell.type = 'value';
    cell.cls = 'pivot-value' + (cell.empty ? ' cursor-default' : '');

    cell.dxId = rric.getIdByIds(response.metaData.dimensions.dx);
    cell.peId = rric.getIdByIds(response.metaData.dimensions.pe);
    cell.ouId = rric.getIdByIds(response.metaData.dimensions.ou);

    return cell;
};

var PlainValueCell = exports.PlainValueCell = function PlainValueCell(value, rric, response) {
    var cell = DefaultCell();

    cell.value = value;
    cell.type = 'value';
    cell.cls = 'pivot-value' + (cell.empty ? ' cursor-default' : ' pointer');

    cell.htmlValue = _typeof(!value) ? '&nbsp;' : value;

    return cell;
};

var ValueSubTotalCell = exports.ValueSubTotalCell = function ValueSubTotalCell(value, htmlValue) {
    var cell = DefaultCell();

    cell.value = value;
    cell.type = 'valueSubtotal';
    cell.cls = 'pivot-value-subtotal';

    cell.empty = value === null || typeof value === 'undefined';

    if (typeof value === 'string') {
        cell.htmlValue = value;
    } else {
        cell.htmlValue = cell.empty ? '&nbsp;' : htmlValue ? htmlValue : (0, _PivotTableUtils.getRoundedHtmlValue)(value);
    }

    return cell;
};

var ValueTotalCell = exports.ValueTotalCell = function ValueTotalCell(value, htmlValue) {
    var cell = DefaultCell();

    cell.value = value;
    cell.type = 'valueTotal';
    cell.cls = 'pivot-value-total-subgrandtotal';

    cell.empty = value === null || typeof value === 'undefined';;

    if (typeof value === 'string') {
        cell.htmlValue = value;
    } else {
        cell.htmlValue = cell.empty ? '&nbsp;' : htmlValue ? htmlValue : (0, _PivotTableUtils.getRoundedHtmlValue)(value);
    }

    return cell;
};

var RowAxisCell = exports.RowAxisCell = function RowAxisCell(axisObject, response, showHierarchy, hidden) {

    if (!axisObject) {
        return null;
    }

    var cell = axisObject;

    cell.collapsed = false;
    cell.hidden = false;
    cell.empty = false;
    cell.width = 120;
    cell.height = 25;

    cell.type = 'dimension';
    cell.axis = 'row';
    cell.cls = 'pivot-dim pivot-row-dim td-nobreak';

    if (showHierarchy) {
        cell.csl += ' align-left';
    }

    cell.noBreak = true;
    cell.hidden = typeof hidden === 'undefined' ? !(axisObject.rowSpan || axisObject.colSpan) : hidden;

    var htmlValue = response.getItemName(cell.id, showHierarchy, true);

    cell.htmlValue = htmlValue;
    cell.title = htmlValue;

    return cell;
};

var ColumnAxisCell = exports.ColumnAxisCell = function ColumnAxisCell(axisObject, response, showHierarchy, sort, hidden) {

    if (!axisObject) {
        return null;
    }

    var cell = axisObject;

    cell.collapsed = false;
    cell.hidden = false;
    cell.empty = false;

    cell.width = 120;
    cell.height = 25;

    cell.type = 'dimension';
    cell.axis = 'column';
    cell.cls = 'pivot-dim pivot-col-dim';

    cell.noBreak = false;
    cell.hidden = typeof hidden === 'undefined' ? !(axisObject.rowSpan || axisObject.colSpan) : hidden;

    if (sort) {
        cell.sort = sort;
        cell.cls += ' td-sortable';
    }

    var htmlValue = response.getItemName(cell.id, showHierarchy, true);

    cell.htmlValue = htmlValue;
    cell.title = htmlValue;

    return cell;
};

var DimensionSubTotalCell = exports.DimensionSubTotalCell = function DimensionSubTotalCell(value, colSpan, rowSpan, empty, hidden) {
    var cell = DefaultCell();

    cell.value = value;
    cell.type = 'dimensionSubtotal';
    cell.cls = 'pivot-dim-subtotal';

    cell.colSpan = colSpan;
    cell.rowSpan = rowSpan;

    cell.empty = empty;
    cell.hidden = hidden;

    return cell;
};

var DimensionGrandTotalCell = exports.DimensionGrandTotalCell = function DimensionGrandTotalCell(value, colSpan, rowSpan, sort, generateUuid) {
    var hidden = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    var cell = DefaultCell();

    cell.value = value;
    cell.type = 'dimensionTotal';
    cell.cls = 'pivot-dim-total';

    cell.colSpan = colSpan;
    cell.rowSpan = rowSpan;

    cell.sort = sort ? 'total' : null;
    cell.uuid = generateUuid ? (0, _uuid2.default)() : null;

    cell.htmlValue = value;
    cell.hidden = hidden;

    return cell;
};

var DimensionEmptyCell = exports.DimensionEmptyCell = function DimensionEmptyCell(colSpan, rowSpan, hidden, style) {
    var cell = DefaultCell();

    cell.value = '&nbsp;';
    cell.type = 'empty';
    cell.cls = 'pivot-empty';

    cell.colSpan = colSpan;
    cell.rowSpan = rowSpan;

    cell.width = colSpan * 120;
    cell.height = rowSpan * 25;

    cell.hidden = hidden;

    cell.style = style;

    return cell;
};

var DimensionLabelCell = exports.DimensionLabelCell = function DimensionLabelCell(value, dim) {
    var cell = DefaultCell();

    cell.value = value;
    cell.type = 'labeled';
    cell.cls = 'pivot-dim-label';

    cell.dim = dim;
    cell.axis = 'row';

    cell.htmlValue = value;

    return cell;
};

var PaddingCell = exports.PaddingCell = function PaddingCell() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var colSpan = arguments[2];
    var rowSpan = arguments[3];
    var hidden = arguments[4];

    var cell = DefaultCell();

    cell.value = '&nbsp;';
    cell.type = 'padding';
    cell.cls = 'pivot-padding';

    cell.width = width;
    cell.height = height;

    cell.colSpan = colSpan;
    cell.rowSpan = rowSpan;

    cell.hidden = hidden;

    return cell;
};

var HorizontalPaddingCell = exports.HorizontalPaddingCell = function HorizontalPaddingCell() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var cls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var hidden = arguments[2];

    var cell = DefaultCell();

    if (typeof hidden === 'undefined') {
        hidden = width <= 0;
    }

    cell.value = '&nbsp;';
    cell.type = 'padding';
    cell.cls = 'pivot-padding ';

    cell.cls += cls;

    cell.width = width;

    cell.hidden = hidden;

    return cell;
};

var VerticalPaddingCell = exports.VerticalPaddingCell = function VerticalPaddingCell() {
    var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var cls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var hidden = arguments[2];

    var cell = DefaultCell();

    if (typeof hidden === 'undefined') {
        hidden = height <= 0;
    }

    cell.value = '&nbsp;';
    cell.type = 'padding';
    cell.cls = 'pivot-padding ';

    cell.cls += cls;

    cell.height = height;

    cell.hidden = hidden;

    return cell;
};

var FilterCell = exports.FilterCell = function FilterCell(text, colSpan) {
    var cell = DefaultCell();

    cell.cls = 'pivot-filter cursor-default', cell.type = 'filter', cell.colSpan = colSpan, cell.title = text, cell.htmlValue = text;

    return cell;
};
//# sourceMappingURL=PivotTableCells.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/table/PivotTableCells.js
 ** module id = 155
 ** module chunks = 0 1
 **/